var D=function(A){return A.AA="AA",A.A="A",A.B="B",A.C="C",A.D="D",A.DD="DD",A.E="E",A.F="F",A.G="G",A.H="H",A.I="I",A}({});export{D as BreastScope};